<template>
  <div class="my-l">
    <div class="lg:grid-cols-12 gap-y-16 lg:gap-y-0 container grid">
      <div class="lg:col-start-2 lg:col-end-6">
        <h2 v-if="heading" class="fluid-3xl leading-tightest lg:pt-16 pr-8" v-html="heading"></h2>
        <div v-if="body" class="fluid-base leading-relaxed font-light mt-10" v-html="body"></div>
        <div v-if="ctaClaim" class="fluid-lg leading-tight font-medium text-br-green mt-4" v-html="ctaClaim"></div>
        <LinkField v-if="cta[0] && cta[0].text" v-bind="cta[0]" class="btn-pill-outline-black mt-8" />
      </div>
      <div class="lg:col-start-7 lg:col-end-12 lg:h-20 relative grid items-end grid-cols-4 mb-20">
        <ParallaxBox class="row-span-full col-start-1 col-end-4" :factor="20" :start-breakpoint="1024">
          <FixedAspect :ratio="1.36" class="lg:hidden block">
            <CldnImg
              v-if="image[0]"
              :src="image[0].url"
              crop="fill"
              sizes="60vw sm:70vw md:30vw lg:20vw xl:20vw 2xl:20vw"
              class="block"
              :alt="imageAlt ? imageAlt : image[0].title"
            />
          </FixedAspect>
          <FixedAspect :ratio="1.28" class="lg:block hidden">
            <CldnImg
              v-if="image[0]"
              :src="image[0].url"
              crop="fill"
              sizes="100vw sm:100vw md:100vw lg:20vw xl:20vw 2xl:20vw"
              class="block"
              :alt="imageAlt ? imageAlt : image[0].title"
            />
          </FixedAspect>
        </ParallaxBox>
        <ParallaxBox class="row-span-full col-start-3 col-end-5 -mb-20" :factor="-20" :start-breakpoint="1024">
          <FixedAspect :ratio="1.43" class="lg:hidden block">
            <CldnImg
              v-if="overlayImage[0]"
              :src="overlayImage[0].url"
              crop="fill"
              sizes="45vw sm:45vw md:45vw lg:20vw xl:20vw 2xl:20vw"
              class="max-w-none block w-full"
              :alt="overlayImageAlt ? overlayImageAlt : overlayImage[0].title"
            />
          </FixedAspect>
          <FixedAspect :ratio="1.23" class="lg:block hidden">
            <CldnImg
              v-if="overlayImage[0]"
              :src="overlayImage[0].url"
              crop="fill"
              sizes="45vw sm:45vw md:45vw lg:20vw xl:20vw 2xl:20vw"
              class="max-w-none block w-full"
              :alt="overlayImageAlt ? overlayImageAlt : overlayImage[0].title"
            />
          </FixedAspect>
        </ParallaxBox>
      </div>
    </div>
  </div>
</template>

<script>
import LinkField from '@/components/common/LinkField';
import CldnImg from '@/components/CldnImg';
import ParallaxBox from '@/components/common/ParallaxBox';
import FixedAspect from '@/components/common/FixedAspect';

export default defineNuxtComponent({
  components: { FixedAspect, LinkField, CldnImg, ParallaxBox },
  props: {
    heading: {
      type: String,
      default: null,
    },
    body: {
      type: String,
      default: null,
    },
    cta: {
      type: Array,
      default: () => [],
    },
    ctaClaim: {
      type: String,
      default: null,
    },
    image: {
      type: Array,
      default: () => [],
    },
    imageAlt: {
      type: String,
      default: null,
    },
    overlayImage: {
      type: Array,
      default: () => [],
    },
    overlayImageAlt: {
      type: String,
      default: null,
    },
  },
});
</script>
